@if (showAddData()) {
<div class="supervisor-dialog-backdrop" (click)="hideAddData()"></div>
<dialog class="supervisor-dialog-add-data" open>
  <app-add-data *ngIf="selectedPatient" [patientSession]="selectedSession()!" [selectedPatientID]="selectedPatient!.ID!"
    (close)="onCloseAddData($event)" />
</dialog>
}

<div class="dashboard">
  <top-bar></top-bar>
  <div class="modules-container">
    <div class="card">
      <div class="card-body" style="padding-left: 2rem; padding-right: 2rem; padding-bottom: 2rem">
        <div class="d-flex justify-content-end"> 
        <!-- Create Session Button -->
        <button pButton type="button" label="Create Session" icon="pi pi-plus" (click)="createSession()" class="p-button-rounded p-button-text p-button-success mb-2"></button>
      </div>
        <!-- Filters
        <p-multiSelect appendTo="body" autoWidth="false" [group]="true" [style]="{ width: '100%' }"
          [options]="possibleFilters()" name="selectedFilters" [(ngModel)]="selectedFilters" display="chip"
          [showClear]="true" placeholder="Select Filters">
          <ng-template let-group pTemplate="group">
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="footer">
            <div class="py-2 px-3">
              <b>
                {{ selectedFilters().length }}
              </b>
              item{{ selectedFilters().length > 1 ? "s" : "" }}
              selected.
            </div>
          </ng-template>
        </p-multiSelect> -->

        <!-- Table -->
        <p-table [value]="filteredSessions()" #dt dataKey="ID" (onRowExpand)="onRowExpand($event)"
          (onRowCollapse)="onRowCollapse($event)" [tableStyle]="{ 'min-width': '70rem' }" editMode="row"
          [loading]="isLoading" [rowHover]="true" [rows]="25" [rowsPerPageOptions]="[10, 25, 50]" [paginator]="true"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 5rem"></th>
              <th pSortableColumn="ServiceID">
                Service <p-sortIcon field="ServiceID" />
              </th>
              <th pSortableColumn="StaffName">
                Staff Names <p-sortIcon field="ServiceID" />
              </th>
              <th pSortableColumn="StartedDate">
                Started Date <p-sortIcon field="StartedDate" />
              </th>
              <th pSortableColumn="FinishedDate">
                Finished Date <p-sortIcon field="FinishedDate" />
              </th>
              <th>Progress Notes</th>
              <th>Handoff Type</th>
              <th style="width: 4rem"></th>
              <th style="width: 4rem"></th>
              <th style="width: 4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-session let-editingSession="editing" let-expanded="expanded"
            let-sessionIndex="rowIndex">
            <tr [pEditableRow]="session">
              <td>
                <span *ngIf="isLoadingSession[session.ID]"><i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i></span>
                <p-button 
                  *ngIf="!isLoadingSession[session.ID]" 
                  type="button" 
                  pRipple 
                  [pRowToggler]="session" 
                  [text]="true" 
                  [rounded]="true" 
                  [plain]="true"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" 
                  [disabled]="isSessionDeleted(session)"
                  />
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    
                    <p-dropdown
                      id="servicesDropdown"
                      filter="true"
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                      [options]="serviceOptions"
                      [(ngModel)]="session.ServiceID"
                      [ngModelOptions]="{standalone: true}"
                      optionLabel="label"
                      optionValue="value"
                      [showClear]="true"
                      [loading]="isLoading"
                    >
                    <ng-template pTemplate="selectedService" let-selectedOption>
                      <div class="flex align-items-center gap-2">
                        <div>
                          <small>Service #{{ selectedOption.value }}</small>    
                          @if (services[selectedOption.value]) {
                            <br> {{ services[selectedOption.value].ServiceDescription }}
                            <br>
                            <small> {{ services[selectedOption.value].Date | date : "MM/dd/yyyy" }} 
                              {{ services[selectedOption.value].StartTime | date : "HH:mm" }}
                              - {{ services[selectedOption.value].EndTime | date : "HH:mm" }}
                            | {{ services[selectedOption.value].StaffNames?.join(', ') }}</small>
                          }

                        </div>
                      </div>
                    </ng-template>
                    </p-dropdown>

                  </ng-template>
                  <ng-template pTemplate="output">
                    
                @if (session.ServiceID) {
                  <small>Service #{{ session.ServiceID }}</small>
                  @if (services[session.ServiceID]) {
                    <br> {{ services[session.ServiceID].ServiceDescription }}
                    <br>
                    <small> {{ services[session.ServiceID].Date | date : "MM/dd/yyyy" }} 
                      {{ services[session.ServiceID].StartTime | date : "HH:mm" }}
                      - {{ services[session.ServiceID].EndTime | date : "HH:mm" }}</small>
                  }
                } @else {
                  <small>Session #{{ session.ID }}</small>
                  <br>No service linked
                 
                }
                @if (isSessionDeleted(session)) {
                  <br> <span style="color: #C15757; font-style: italic;">Deleted on {{ session.DeletedDate | date : "MM/dd/yyyy HH:mm" }}</span>
                }
                @if (!session.FinishedDate) {
                @if (isLoggedUserOnSession(session) && !isSessionDeleted(session)) {
                <a [routerLink]="[
                    '/staff/home/' + (session.PatientID ?? selectedPatient?.ID) + '/' + session.ID
                  ]">
                  <i style="background: green;
                  padding: 5px;
                  border-radius: 20px;
                  padding-left: 7px;" class="pi pi-play text-white ms-2"></i>
                </a>
                } @else if (!isSessionDeleted(session)) {
                <i title="This service is assigned to another staff member" 
                style="background: gray; cursor: not-allowed;
                  padding: 5px;
                  border-radius: 20px;
                  padding-left: 7px;" class="pi pi-play text-white ms-2"></i>
                }
                }

                @if (hasUnsyncedOfflineData(session)) {
                  <button
                  pButton
                  pRipple
                  type="button"
                  [icon]="'pi pi-sync'"
                  (click)="syncPatientData()"
                  class="ms-2 p-button-rounded p-button-outlined p-button-info bg-danger text-white"
                  [pTooltip]="'Sync Data'"
                  tooltipPosition="bottom"
                  style="width: 28px;height: 28px;"
                ></button>
                }
                </ng-template>
              </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="output">                
                    {{ getStaffNamesForSession(session) }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText type="datetime-local" [(ngModel)]="session.StartedDate" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ session.StartedDate | date : "MM/dd/yyyy HH:mm" }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText type="datetime-local" [(ngModel)]="session.FinishedDate" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ session.FinishedDate | date : "MM/dd/yyyy HH:mm" }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                @if (session.FinishedDate) {
                  <button pButton type="button" label="View" icon="pi pi-eye" (click)="viewProgressNotes(session)" title="View Progress Notes" class="p-button-rounded p-button-text p-button-success mb-2"></button>
                }
              </td>
              <td>
                @if (shouldShowHandoffViewButtonForSession(session)) {
                  <p-tag icon="pi pi-info-circle" [value]="handOffTextForSession(session)" [severity]="severityForHandoffTypeOfSession(session)" (click)="onHandoffBadgeClick(session)" [style]="{ cursor: 'pointer' }" [pTooltip]="temporaryHandoffTooltip(session)" tooltipPosition="bottom" />
                } @else {
                  <p-tag [value]="handOffTextForSession(session)" [severity]="severityForHandoffTypeOfSession(session)" [pTooltip]="temporaryHandoffTooltip(session)" tooltipPosition="bottom" />
                }
              </td>
              <td>
                <div class="flex align-items-center justify-content-center">
                  <button
                    *ngIf="!editingSession"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-info-circle"
                    [disabled]="isSessionDeleted(session)"
                    (click)="viewClientInfo(session)"
                    class="p-button-rounded p-button-text"
                    [pTooltip]="'Client Info'"
                    tooltipPosition="bottom">
                  </button>
                </div>
              </td>
              <td>
                <div class="flex align-items-center justify-content-center gap-2">
                  <button 
                    *ngIf="!editingSession && session.FinishedDate && !isSessionDeleted(session) && hasSupervisorPermission()" 
                    pButton 
                    pRipple 
                    type="button" 
                    icon="pi pi-refresh"
                    (click)="showReopenSessionAlert(session)" 
                    class="p-button-rounded p-button-text p-button-info"
                    [pTooltip]="'Reopen Session'"
                    tooltipPosition="bottom">
                  </button>
                  <button 
                    *ngIf="!editingSession" 
                    pButton 
                    pRipple 
                    type="button" 
                    pInitEditableRow 
                    icon="pi pi-pencil"
                    [disabled]="isSessionDeleted(session)"
                    (click)="onSessionEditInit(session)" 
                    class="p-button-rounded p-button-text">
                  </button>
                  <button *ngIf="editingSession" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                    (click)="onSessionEditSave(session)"
                    class="p-button-rounded p-button-text p-button-success mr-2"></button>
                  <button *ngIf="editingSession" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                    (click)="onSessionEditCancel(session, sessionIndex)"
                    class="p-button-rounded p-button-text p-button-danger"></button>
                </div>
              </td>
              <td>
                <button 
                  *ngIf="!editingSession" 
                  pButton 
                  pRipple 
                  type="button" 
                  icon="pi pi-plus"
                  [disabled]="isSessionDeleted(session)"
                  (click)="showAddDataAlert(session)" 
                  class="p-button-rounded"
                  style="width: 2rem; height: 2rem; border-radius: 20%; border: 1px solid #9382ad; background-color: #9382ad; color: white;"></button>
                <button *ngIf="editingSession" pButton pRipple type="button" icon="pi pi-trash"
                  (click)="showDeleteSessionAlert(session)" class="p-button-rounded p-button-text p-button-danger"
                  style="width: 2rem; height: 2rem; border-radius: 20%; border: 1px solid #C15757; background-color: #c15757; color: white;"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="expandedrow" let-session>
            <tr>
              <td colspan="10">
                <div class="p-3">
                  <app-session [session]="session" [targets]="targets()" [behaviors]="behaviors()"
                    [antecedents]="antecedents" [consequences]="consequences" [locations]="locations"
                    [responses]="responses" [severities]="severities" [defaultPromptCodes]="defaultPromptCodes"
                    (onSessionDataDeleted)="onSessionDataDeleted($event)" />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      
        <div class="d-flex justify-content-end"> 
          <button pButton type="button" label="{{showDeletedSessions()?'Hide':'Show'}} Deleted Sessions" icon="{{showDeletedSessions()?'pi pi-eye-slash':'pi pi-eye'}}" (click)="showDeletedSessions.set(!showDeletedSessions())" class="p-button-rounded p-button-text p-button-danger mb-2"></button>
          <button pButton type="button" label="Preview Session" icon="pi pi-eye" (click)="previewSession()" class="p-button-rounded p-button-text p-button-success mb-2"></button>
        </div>
       
      </div>
    </div>
  </div>
</div>

@if (showProgressNotes()) {
  <div class="supervisor-dialog-backdrop" (click)="closeProgressNote()"></div>
<dialog class="supervisor-dialog progress-note-background"  open>
  <app-progress-note class="progress-note-inner" [isPreview]="true" [PatientSessionID]="sessionToShowProgressNote()?.ID ?? 0" 
    #progressNoteComponent [targets]="targets()" [behaviors]="behaviors()"
    [programs]="programs()" (endSessionEvent)="closeProgressNote()" [patientSessionForPreview]="sessionToShowProgressNote()"/>
</dialog>
}

@if (showClientInfo()) {
  <div class="supervisor-dialog-backdrop" (click)="closeClientInfo()"></div>
  <dialog class="supervisor-dialog bg-white" open>
    <div class="p-3" style="min-width: 24rem; color: black;">
      <h3 class="mb-3">Client Info</h3>
      <div class="mb-2"><strong>Name:</strong> {{ clientInfoSession()?.ServicePatientInfo?.Name || 'N/A' }}</div>
      <div class="mb-2"><strong>Phone:</strong> {{ clientInfoSession()?.ServicePatientInfo?.PrimaryPhone || 'N/A' }}</div>
      <div class="mb-2"><strong>Address:</strong> {{ clientInfoSession()?.ServicePatientInfo?.PatientAddress || 'N/A' }}</div>
      
      <!-- Service-specific info section -->
      <hr class="my-3">
      <h4 class="mb-2">Service Information</h4>
      <div class="mb-2"><strong>Service Location:</strong> {{ clientInfoSession()?.ServicePatientInfo?.ServiceLocationName || 'N/A' }}</div>
      <div class="mb-2"><strong>Service Address:</strong> {{ clientInfoSession()?.ServicePatientInfo?.ServiceLocationAddress || 'N/A' }}</div>
    </div>
    <div class="d-flex justify-content-end p-3 pt-0">
      <button pButton type="button" label="Close" class="p-button-text" (click)="closeClientInfo()"></button>
    </div>
  </dialog>
}

@if (showHandoffInfo()) {
  <div class="supervisor-dialog-backdrop" (click)="!isEditMode() && closeHandoffInfo()"></div>
  <dialog class="supervisor-dialog bg-white" open>
    <div class="p-3" style="min-width: 24rem; color: black;">
      <h3 class="mb-3">{{ formattedSessionName(handoffInfoSession()) }}</h3>
      
      @if (!isEditMode()) {
        <!-- View Mode: Handoff Type Badge -->
        <div class="mb-3" style="display: flex; justify-content: center;">
          <p-tag 
            [value]="handOffTextForSession(handoffInfoSession()!)" 
            [severity]="severityForHandoffTypeOfSession(handoffInfoSession()!)"
            [style]="{
              'font-weight': 'bold',
              'font-size': '1.1rem',
              'padding': '0.5rem 1rem',
              'border-radius': '9999px'
            }"
          />
        </div>

        <!-- View Mode: Explanation Content -->
        @if (handoffInfoSession()?.Explanation) {
          <div class="mb-3">
            <strong>Explanation:</strong>
            <div class="mt-2" style="padding: 0.75rem; background-color: #f8f9fa; border-radius: 6px;">
              {{ handoffInfoSession()?.Explanation }}
            </div>
          </div>
        }

        <!-- View Mode: Guardian Information (only if IsHandoffToParent) -->
        @if (handoffInfoSession()?.IsHandoffToParent) {
          <hr class="my-3">
          <h4 class="mb-2">Guardian Information</h4>

          @if (handoffInfoSession()?.FinishedDate) {
            <div class="mb-2" style="display: flex; justify-content: space-between; align-items: center;">
              <strong>Guardian Handoff Time:</strong>
              <span>{{ handoffInfoSession()?.FinishedDate | date : "MM/dd/yyyy hh:mm a" }}</span>
            </div>
          }
          
          <div class="mb-2" style="display: flex; justify-content: space-between; align-items: center;">
            <strong>Guardian Name:</strong>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              @if (isLoadingGuardianName()) {
                <i class="pi pi-spin pi-spinner" style="font-size: 0.875rem;"></i>
                <span style="color: #6c757d; font-style: italic;">Loading...</span>
              } @else if (handoffGuardianName()) {
                <span>{{ handoffGuardianName() }}</span>
              } @else {
                <span style="color: #6c757d; font-style: italic;">Not specified</span>
              }
            </div>
          </div>

          <div class="mb-2">
            <strong>Signature:</strong>
            <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem;">
              @if (isLoadingSignature()) {
                <i class="pi pi-spin pi-spinner" style="font-size: 0.875rem;"></i>
                <span style="color: #6c757d; font-style: italic;">Loading...</span>
              } @else if (handoffSignatureUrl()) {
                <div style="border: 1px solid #ced4da; border-radius: 6px; padding: 1rem; background-color: #f8f9fa; width: 100%;">
                  <img 
                    [src]="handoffSignatureUrl()!" 
                    alt="Guardian Signature" 
                    style="max-width: 100%; height: auto; display: block;"
                  />
                </div>
              } @else {
                <span style="color: #6c757d; font-style: italic;">Not available</span>
              }
            </div>
          </div>
        }

        @if (
          handoffInfoSession()?.IsHandoffToStaff ||
          handoffInfoSession()?.IsTemporaryHandoff ||
          handoffInfoSession()?.TemporaryHandoffStaffID
        ) {
          <hr class="my-3">
          <h4 class="mb-2">Staff Handoff Information</h4>

          <div class="mb-2" style="display: flex; justify-content: space-between; align-items: center;">
            <strong>Staff Name:</strong>
            <span>{{
              handoffInfoSession()?.TemporaryHandoffStaffName ||
              handoffInfoSession()?.HandoffStaffName ||
              handoffInfoSession()?.StaffName ||
              'Not specified'
            }}</span>
          </div>

          @if (handoffInfoSession()?.TemporaryHandoffStartedDate) {
            <div class="mb-2" style="display: flex; justify-content: space-between; align-items: center;">
              <strong>Temporary Handoff Start:</strong>
              <span>{{ handoffInfoSession()?.TemporaryHandoffStartedDate | date : "MM/dd/yyyy hh:mm a" }}</span>
            </div>
          } @else if (handoffInfoSession()?.FinishedDate) {
            <div class="mb-2" style="display: flex; justify-content: space-between; align-items: center;">
              <strong>Staff Handoff Time:</strong>
              <span>{{ handoffInfoSession()?.FinishedDate | date : "MM/dd/yyyy hh:mm a" }}</span>
            </div>
          }

          @if (handoffInfoSession()?.TemporaryHandoffEndedDate) {
            <div class="mb-2" style="display: flex; justify-content: space-between; align-items: center;">
              <strong>Temporary Handoff End:</strong>
              <span>{{ handoffInfoSession()?.TemporaryHandoffEndedDate | date : "MM/dd/yyyy hh:mm a" }}</span>
            </div>
          }

          <div class="mb-2">
            <strong>Signature:</strong>
            <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem;">
              @if (isLoadingStaffSignature()) {
                <i class="pi pi-spin pi-spinner" style="font-size: 0.875rem;"></i>
                <span style="color: #6c757d; font-style: italic;">Loading...</span>
              } @else if (handoffStaffSignatureUrl()) {
                <div style="border: 1px solid #ced4da; border-radius: 6px; padding: 1rem; background-color: #f8f9fa; width: 100%;">
                  <img
                    [src]="handoffStaffSignatureUrl()!"
                    alt="Staff Handoff Signature"
                    style="max-width: 100%; height: auto; display: block;"
                  />
                </div>
              } @else {
                <span style="color: #6c757d; font-style: italic;">Not available</span>
              }
            </div>
          </div>
        }
      } @else {
        <!-- Edit Mode: Handoff Type Dropdown -->
        <div class="mb-3" style="display: flex; justify-content: center;">
          <p-dropdown
            [options]="[
              { label: 'Handoff to Staff', value: 'staff' },
              { label: 'Temporary Handoff', value: 'temporary' },
              { label: 'Handoff to Parent', value: 'parent' }
            ]"
            [(ngModel)]="editHandoffType"
            [ngModelOptions]="{standalone: true}"
            optionLabel="label"
            optionValue="value"
            placeholder="Select handoff type"
            [style]="{ width: '250px' }"
            (onChange)="onHandoffTypeChange()"
          ></p-dropdown>
        </div>

        <!-- Edit Mode: Explanation Field (always visible) -->
        <div class="mb-3">
          <label for="editExplanation"><strong>Explanation:</strong></label>
          <textarea
            id="editExplanation"
            pTextarea
            [(ngModel)]="editExplanation"
            [ngModelOptions]="{standalone: true}"
            [rows]="4"
            [style]="{ width: '100%' }"
            placeholder="Enter explanation (optional)"
          ></textarea>
        </div>

        <!-- Edit Mode: Staff/Temporary Signature -->
        @if (editHandoffType() === 'staff' || editHandoffType() === 'temporary') {
          <hr class="my-3">
          <h4 class="mb-2">
            {{ editHandoffType() === 'temporary' ? 'Temporary Handoff' : 'Staff Handoff' }} Signature
          </h4>

          @if (editHandoffType() === 'temporary') {
            <div class="mb-3">
              <label for="editTemporaryStaffForTemporaryType"><strong>Temporary Staff:</strong></label>
              <p-dropdown
                id="editTemporaryStaffForTemporaryType"
                [options]="editTemporaryStaffOptions()"
                [(ngModel)]="editTemporaryStaff"
                [ngModelOptions]="{standalone: true}"
                optionLabel="FullName"
                placeholder="Select temporary staff"
                appendTo="body"
                [filter]="true"
                filterBy="FullName"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </div>
          }

          <div class="mb-3">
            <label><strong>Current Signature:</strong></label>
            <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem;">
              @if (isLoadingStaffSignature()) {
                <i class="pi pi-spin pi-spinner" style="font-size: 0.875rem;"></i>
                <span style="color: #6c757d; font-style: italic;">Loading...</span>
              } @else if (handoffStaffSignatureUrl()) {
                <div style="border: 1px solid #ced4da; border-radius: 6px; padding: 1rem; background-color: #f8f9fa; width: 100%;">
                  <img
                    [src]="handoffStaffSignatureUrl()!"
                    alt="Current Staff Handoff Signature"
                    style="max-width: 100%; height: auto; display: block;"
                  />
                </div>
              } @else {
                <span style="color: #6c757d; font-style: italic;">Not available</span>
              }
            </div>
          </div>

          <div class="mb-3">
            <label><strong>New Signature (optional):</strong></label>
            <div class="mt-2" style="border: 1px solid #ced4da; border-radius: 6px; padding: 1rem;">
              <signature-pad
                class="border-sign"
                [options]="signaturePadOptions"
              ></signature-pad>
            </div>
          </div>
        }

        <!-- Edit Mode: Guardian Information (only if Parent is selected) -->
        @if (editHandoffType() === 'parent') {
          <hr class="my-3">
          <h4 class="mb-2">Guardian Information</h4>
          
          <div class="mb-3">
            <label for="editGuardian"><strong>Select Guardian:</strong></label>
            <p-dropdown
              id="editGuardian"
              [options]="editGuardians()"
              [(ngModel)]="editGuardian"
              [ngModelOptions]="{standalone: true}"
              optionLabel="Name"
              placeholder="Select a guardian"
              appendTo="body"
              [style]="{ width: '100%' }"
            ></p-dropdown>
          </div>

          @if (editGuardian() && editGuardian().Name === 'Other') {
            <div class="mb-3">
              <label for="editOtherGuardianName"><strong>Enter Guardian Name:</strong></label>
              <input
                id="editOtherGuardianName"
                type="text"
                pInputText
                [(ngModel)]="editOtherGuardianName"
                [ngModelOptions]="{standalone: true}"
                [style]="{ width: '100%' }"
                placeholder="Enter guardian name"
              />
            </div>
          }

          <div class="mb-3">
            <label><strong>Guardian Signature:</strong></label>
            <div class="mt-2" style="border: 1px solid #ced4da; border-radius: 6px; padding: 1rem;">
              <signature-pad 
                class="border-sign" 
                [options]="signaturePadOptions"
              ></signature-pad>
            </div>
          </div>

          @if (
            handoffInfoSession()?.IsTemporaryHandoff ||
            handoffInfoSession()?.TemporaryHandoffStaffID ||
            handoffInfoSession()?.TemporaryHandoffStaffName ||
            handoffInfoSession()?.TemporaryHandoffStartedDate ||
            handoffInfoSession()?.TemporaryHandoffEndedDate
          ) {
            <hr class="my-3">
            <h4 class="mb-2">Temporary Handoff Details</h4>

            <div class="mb-3">
              <label for="editTemporaryStaff"><strong>Temporary Staff:</strong></label>
              <p-dropdown
                id="editTemporaryStaff"
                [options]="editTemporaryStaffOptions()"
                [(ngModel)]="editTemporaryStaff"
                [ngModelOptions]="{standalone: true}"
                optionLabel="FullName"
                placeholder="Select temporary staff"
                appendTo="body"
                [filter]="true"
                filterBy="FullName"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </div>

            <div class="mb-3">
              <button
                pButton
                type="button"
                label="Edit Temporary Handoff Signature"
                icon="pi pi-pencil"
                (click)="openEditTemporarySignatureDialog()"
                class="p-button-outlined"
              ></button>
            </div>
          }
        }
      }
    </div>
    <div class="d-flex justify-content-between p-3 pt-0">
      @if (!isEditMode()) {
        <button 
          pButton 
          type="button" 
          label="Edit" 
          icon="pi pi-pencil" 
          (click)="editHandoffInfo()"
          class="p-button-text"
        ></button>
        <button 
          pButton 
          type="button" 
          label="Close" 
          class="p-button-text" 
          (click)="closeHandoffInfo()"
        ></button>
      } @else {
        <button 
          pButton 
          type="button" 
          label="Cancel" 
          icon="pi pi-times" 
          (click)="cancelEdit()"
          class="p-button-text"
        ></button>
        <button 
          pButton 
          type="button" 
          label="Save" 
          icon="pi pi-check" 
          (click)="saveHandoffInfo()"
          class="p-button-text p-button-success"
          [disabled]="isLoading"
        ></button>
      }
    </div>
  </dialog>
}

@if (showEditTemporarySignature()) {
  <div class="supervisor-dialog-backdrop" (click)="closeEditTemporarySignatureDialog()"></div>
  <dialog class="supervisor-dialog bg-white" open>
    <div class="p-3" style="min-width: 24rem; color: black;">
      <h3 class="mb-3">Edit Temporary Handoff Signature</h3>
      <div class="mb-3">
        <label><strong>New Signature:</strong></label>
        <div class="mt-2" style="border: 1px solid #ced4da; border-radius: 6px; padding: 1rem;">
          <signature-pad
            #temporarySignatureEditPad
            class="border-sign"
            [options]="signaturePadOptions"
          ></signature-pad>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between p-3 pt-0">
      <button
        pButton
        type="button"
        label="Cancel"
        icon="pi pi-times"
        (click)="closeEditTemporarySignatureDialog()"
        class="p-button-text"
      ></button>
      <button
        pButton
        type="button"
        label="Save Signature"
        icon="pi pi-check"
        (click)="saveTemporaryHandoffSignatureEdit()"
        class="p-button-text p-button-success"
      ></button>
    </div>
  </dialog>
}

@if (showTemporaryHandoffEnd()) {
  <div class="supervisor-dialog-backdrop" (click)="closeTemporaryHandoffEndDialog()"></div>
  <dialog class="supervisor-dialog bg-white" open>
    <div class="p-3" style="min-width: 24rem; color: black;">
      <h3 class="mb-3">Temporary handoff ended - handoff to guardian</h3>
      <div class="mb-3">
        <label for="temporaryGuardian"><strong>Select Guardian:</strong></label>
        <p-dropdown
          id="temporaryGuardian"
          [options]="temporaryGuardians()"
          [(ngModel)]="temporaryGuardian"
          [ngModelOptions]="{standalone: true}"
          optionLabel="Name"
          placeholder="Select a guardian"
          appendTo="body"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>

      @if (temporaryGuardian() && temporaryGuardian().Name === 'Other') {
        <div class="mb-3">
          <label for="temporaryOtherGuardianName"><strong>Enter Guardian Name:</strong></label>
          <input
            id="temporaryOtherGuardianName"
            type="text"
            pInputText
            [(ngModel)]="temporaryOtherGuardianName"
            [ngModelOptions]="{standalone: true}"
            [style]="{ width: '100%' }"
            placeholder="Enter guardian name"
          />
        </div>
      }

      <div class="mb-3">
        <label><strong>Guardian Signature:</strong></label>
        <div class="mt-2" style="border: 1px solid #ced4da; border-radius: 6px; padding: 1rem;">
          <signature-pad class="border-sign" [options]="signaturePadOptions"></signature-pad>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between p-3 pt-0">
      <button
        pButton
        type="button"
        label="Cancel"
        icon="pi pi-times"
        (click)="closeTemporaryHandoffEndDialog()"
        class="p-button-text"
      ></button>
      <button
        pButton
        type="button"
        label="Temporary handoff ended - handoff to guardian"
        icon="pi pi-check"
        (click)="finalizeTemporaryHandoffToGuardian()"
        class="p-button-text p-button-success"
        [disabled]="isLoading"
      ></button>
    </div>
  </dialog>
}

@if (isLoading) {
<app-loading-indicator />
}